import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './store/AuthContext';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import PrivateRoute from './components/routes/PrivateRoute';
import AdminRoute from './components/routes/AdminRoute';
import SalesPage from './pages/reports/SalesPage';
import GasPurchaseForm from './pages/distribution/GasPurchaseForm';
import PurchasesPage from './pages/reports/PurchasesPage';
import GasSaleForm from './pages/distribution/GasSaleForm';
import POSForm from './pages/distribution/POSForm';
import POSPage from './pages/reports/POSPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/sell"
            element={
              <PrivateRoute>
                <GasPurchaseForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route path="/purchase/:locationId" element={<GasPurchaseForm />} />
          <Route path="/sales/:locationId" element={<GasSaleForm />} />

          <Route path="/salesreport/:locationId" element={<SalesPage />} />
          <Route path="/purchasereport/:locationId" element={<PurchasesPage />} />

          <Route path="/pos/:locationId" element={<POSForm />} />
          <Route path="/posreport/:locationId" element={<POSPage />} />

          <Route path="/" element={<Navigate to="/dashboard" />} />

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;